import { render, staticRenderFns } from "./DemoInterviewFetcher.vue?vue&type=template&id=3c0003ac&scoped=true&"
import script from "./DemoInterviewFetcher.vue?vue&type=script&lang=js&"
export * from "./DemoInterviewFetcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0003ac",
  null
  
)

export default component.exports